import clsx from 'clsx'
import { CircleIcon } from 'lucide-react'

import { SolidCircleCheckIcon } from 'slab'

import TimelineCard, { type TimelineCardProps } from './TimelineCard'

export type TimelineItem = TimelineCardProps
export type TimelineProps = {
  items: TimelineItem[]
}

const timelineItemIcon = (item: TimelineItem) => {
  if (item.isCompleted) {
    return <SolidCircleCheckIcon size={14} className='text-green-400' />
  } else if (item.isActive) {
    return <div className='h-[10px] w-[10px] rounded-full bg-gray-600' />
  }

  return <CircleIcon size={14} className='text-gray-500' />
}

export default function Timeline ({ items }: TimelineProps) {
  return (
    <div className='flex flex-col'>
      {items.map((item, index) => (
        <div key={index} className='flex flex-row gap-2 group'>
          <div className='flex flex-col items-center'>
            <div className={clsx('w-[1px] h-3.5 bg-gray-200 rounded-lg group-first:w-0', {
              'bg-green-400': items[index - 1]?.isCompleted,
            })}
            />
            <div className='flex items-center justify-center h-6 w-6 shrink-0'>
              {timelineItemIcon(item)}
            </div>
            <div className={clsx('flex-1 w-[1px] bg-gray-200 rounded-lg group-last:w-0', {
              'bg-green-400': item.isCompleted,
            })}
            />
          </div>
          <div className='pb-4 group-last:pb-0'>
            <TimelineCard {...item} />
          </div>
        </div>
      ))}
    </div>
  )
}
